import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import * as actions from './actions';
import { editorAction, editorState } from './types';

import msg from '../../i18n/ko.json';

import { boxDefault, buttonDefault, linkDefault, partitionDefault, textDefault } from '../../config/components';

import { option } from '../../config/options';

const initialState: editorState = {
	contents: [],
	testGroup: undefined,
	selectedContentId: -1,
	prevSelectedContentId: -1,
	markedToolbar:{
		contentId: -1,
		currentIndex: -1,
		itemType: ''
	},
	emailId: -1,
	email: {
		id: -1,
		listId: -1
	},
	listVars: [],
	listInfo: {
		id: -1
	},
	systemFields: {
		systemMergeEmailFields: [],
		systemMergeListFields: [],
		systemMergeSubscriberFields: [],
		systemMergeURLFields: []
	},
	history: {},
	container: {
		background: '#ffffff',
		backgroundFull: '',
		borderWidth: '',
		borderStyle: 'solid',
		borderColor: '',
		pallette: '',
		margin: "0px auto",
		commonStyle: {
			box: boxDefault,
			text: textDefault,
			button: buttonDefault,
			link: linkDefault,
			partition: partitionDefault,
			outer: {
				paddingTop: "0",
				paddingBottom: "0",
			}
		}
	},
	service: {
		totalSize: 0,
		msg: msg
	},
	ui: {
		conetentsLoading: {},
		isContentsLoading: true,
		addContentCanDrop: false,
		contentsSaving: false,
		contentsSaveError: false,
		showHistory: false,
		showsSidebar: false,
		dialog: {
			show: false,
			msg: '',
			callback: null
		},
		screenMode: 'desktop',
		isLoadingPreview: false,
		tokenWarning: {
			show: false,
			message: ''
		}
	},
	option: option,
	defaultShop: {
		mall_id: '',
		shop_no: -1,
		shop_name: '',
		base_domain: '',
		primary_domain: '',
		language: '',
		currency: '',
		use_reference_currency: true,
		company_name: '',
		address: '',
		phone: '',
		list_id: -1,
		is_default: false,
	},
	shops: [],
	savedBoxes: [],
	savedBoxesMeta: null,
	savedBoxesLoading: false,
	renamingBoxes: {} as { [boxId: string]: boolean },
	deletingBoxes: {} as { [boxId: string]: boolean },
	addingBoxes: {} as { [boxId: string]: boolean },
	adKeyword: '',
};

const editor = createReducer<editorState, editorAction>(initialState, {
	[actions.GET_CONTENTS]: (state) => ({
		...state,
		contents: []
	}),
	[actions.GET_CONTENTS_SUCCESS]: (state, action) => ({
		...state,
		contents : action.payload,
	}),
	[actions.GET_CONTENTS_ERROR]: (state, action) => ({
		...state,
		contents: []
	}),
	[actions.SWITCH_TEST_GROUP]: (state, action) => ({
		...state,
		emailId: action.payload,
	}),
	[actions.SET_TEST_GROUP]: (state, action) => ({
		...state,
		testGroup: action.payload,
	}),
	[actions.SYNC_TEST_GROUP_CONTENTS]: (state, action) => ({
		...state,
		emailId: action.payload,
	}),
	[actions.SET_EMAIL_ID]: (state, action) => ({
		...state,
		emailId: action.payload
	}),
	[actions.GET_EMAIL]: (state) => ({
		...state,
		email: {
			id: -1
		}
	}),
	[actions.GET_EMAIL_SUCCESS]: (state, action) => ({
		...state,
		email: action.payload,
	}),
	[actions.GET_EMAIL_ERROR]: (state, action) => ({
		...state,
		email: {
			id: -1
		}
	}),
	[actions.GET_CONTAINER]: (state) => ({
		...state,
	}),
	[actions.GET_CONTAINER_SUCCESS]: (state, action) => ({
		...state,
		container: action.payload,
	}),
	[actions.GET_CONTAINER_ERROR]: (state, action) => ({
		...state,
	}),
	[actions.EDIT_CONTAINER]: (state, action) => ({
		...state,
		container: action.payload
	}),
	[actions.GET_HISTORY]: (state) => ({
		...state,
	}),
	[actions.GET_HISTORY_SUCCESS]: (state, action) =>
	{
		if (action.payload.offset === 0) {
			return {
				...state,
				history: action.payload,
			}
		} else {
			return {
				...state,
				history: {
					total: action.payload.total,
					limit: action.payload.limit,
					offset: action.payload.offset,
					items: state.history.items?.concat(action.payload.items),
				}
			}
		}
	},
	[actions.GET_HISTORY_ERROR]: (state, action) => ({
		...state,
	}),
	[actions.GET_FILESIZE]: (state) => ({
		...state,
	}),
	[actions.GET_FILESIZE_SUCCESS]: (state, action) => ({
		...state,
		service: {
			...state.service, 
			totalSize: action.payload.totalSize
		},
	}),
	[actions.GET_FILESIZE_ERROR]: (state, action) => ({
		...state,
	}),
	[actions.APPLY_FILESIZE]: (state) => ({
		...state,
	}),
	[actions.EDIT_CONTENT]: (state, action) => ({
		...state
	}),
	[actions.MOVE_CONTENT]: (state, action) => ({
		...state
	}),
	[actions.SELECT_CONTENT]: (state, action) => ({
		...state,
		selectedContentId: action.payload,
		prevSelectedContentId: state.selectedContentId
	}),	
	[actions.ADD_CONTENT_CANDROP]: (state, action) => ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.addContentCanDrop = action.payload;
		})
	}),
	[actions.SAVE_CONTENTS]: (state, action) => ({
		...state,
	}),
	[actions.SAVE_CONTENTS_SUCCESS]: (state, action) => ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.contentsSaveError = false;
		})
	}),
	[actions.SAVE_CONTENTS_ERROR]: (state, action) => ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.contentsSaveError = true;
		})
	}),
	[actions.TOGGLE_IS_SAVING]: (state, action) => {
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.contentsSaving = action.payload;
			if (action.payload === true) {
				draft.contentsSaveError = false;
			}
		})
	})},
	[actions.TOGGLE_IS_CONTENTS_LOADING]: (state, action) => {
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.isContentsLoading = action.payload;
		})
	})},
	[actions.TOGGLE_CONTENTS_TARGET_LOADING]: (state, action) => {
		const { target, isLoading } = action.payload;
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			if (isLoading) {
				draft.conetentsLoading[target] = isLoading;
			} else {
				delete draft.conetentsLoading[target];
			}
		})
	})},
	[actions.SET_MARKED_TOOLBAR]: (state, action) => {
		if(JSON.stringify(state.markedToolbar) == JSON.stringify(action.payload)){
			return state;
		}
		return ({
		...state,
		markedToolbar: {
			...action.payload
		}
	})},
	[actions.TOGGLE_SHOW_HISTORY]: (state, action) => {
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.showHistory = action.payload;
		})
	})},
	[actions.GET_SYSTEMFIELDS]: (state) => ({
		...state,
	}),
	[actions.GET_SYSTEMFIELDS_SUCCESS]: (state, action) => ({
		...state,
		systemFields: action.payload,
	}),
	[actions.GET_SYSTEMFIELDS_ERROR]: (state, action) => ({
		...state,
		systemFields: {
			systemMergeEmailFields: [],
			systemMergeListFields: [],
			systemMergeSubscriberFields: [],
			systemMergeURLFields: []
		}
	}),
	[actions.GET_LISTVARS]: (state) => ({
		...state,
	}),
	[actions.GET_LISTVARS_SUCCESS]: (state, action) => ({
		...state,
		listVars: action.payload,
	}),
	[actions.GET_LISTVARS_ERROR]: (state, action) => ({
		...state,
		listVars: []
	}),
	[actions.GET_LISTINFO]: (state) => ({
		...state,
	}),
	[actions.GET_LISTINFO_SUCCESS]: (state, action) => ({
		...state,
		listInfo: action.payload,
	}),
	[actions.GET_LISTINFO_ERROR]: (state, action) => ({
		...state,
		listInfo: {
			id: -1
		}
	}),
	[actions.SET_SHOPS]: (state, action) => ({
		...state,
		shops: action.payload,
	}),
	[actions.SET_DEFAULT_SHOP]: (state, action) => ({
		...state,
		defaultShop: action.payload,
	}),
	[actions.INIT_SIDEBAR]: (state, action) => {
		const showsSidebar = window.sessionStorage.getItem('showsSidebar') !== 'false';
		return {
			...state,
			ui: {
				...state.ui,
				showsSidebar,
			}
		}
	},
	[actions.SHOW_SIDEBAR]: (state, action) => {
		window.sessionStorage.setItem('showsSidebar', 'true');
		return {
			...state,
			ui: {
				...state.ui,
				showsSidebar: true,
			}
		}
	},
	[actions.HIDE_SIDEBAR]: (state, action) => {
		window.sessionStorage.setItem('showsSidebar', 'false');
		return {
			...state,
			ui: {
				...state.ui,
				showsSidebar: false,
			}
		}
	},
	[actions.DIALOG_SHOW]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				dialog: {
					show: true,
					msg: action.payload.msg,
					msgsub: action.payload.msgsub,
					callback: action.payload.callback,
				}
			}
		}
	},
	[actions.DIALOG_HIDE]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				dialog: {
					show: false,
					msg: '',
					callback: null
				}
			}
		}
	},
	[actions.CHANGE_SCREENMODE]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				screenMode: action.payload
			}
		}
	},
	[actions.REQUEST_OPEN_PREVIEW]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				isLoadingPreview: true,
			}
		}
	},
	[actions.FINISH_LOADING_PREVIEW]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				isLoadingPreview: false,
			}
		}
	},
	// Saved Box Reducers  
	[actions.LOAD_SAVED_BOXES]: (state) => ({
		...state,
		savedBoxesLoading: true,
	}),
	[actions.LOAD_SAVED_BOXES_SUCCESS]: (state, action) => ({
		...state,
		savedBoxes: action.payload.isLoadMore 
			? [...state.savedBoxes, ...action.payload.boxes]  // 더보기: 기존 목록에 추가
			: action.payload.boxes,  // 새로고침: 전체 교체
		savedBoxesMeta: action.payload.meta,  // 페이지네이션 정보
		savedBoxesLoading: false,
	}),
	[actions.LOAD_SAVED_BOXES_ERROR]: (state, action) => ({
		...state,
		savedBoxesLoading: false,
		// 에러 시에도 기존 데이터는 유지
	}),
	[actions.SAVE_BOX_SUCCESS]: (state, action) => 
		produce(state, draft => {
			// 이미 saga에서 로드하므로 여기서는 특별한 처리 필요없음
		}),
	[actions.RENAME_SAVED_BOX]: (state, action) => 
		produce(state, draft => {
			const boxId = action.payload.id;
			draft.renamingBoxes[boxId] = true;
		}),
	[actions.RENAME_SAVED_BOX_SUCCESS]: (state, action) => 
		produce(state, draft => {
			// 모든 로딩 상태 해제 (목록이 새로워짐)
			draft.renamingBoxes = {};
		}),
	[actions.RENAME_SAVED_BOX_ERROR]: (state, action) => 
		produce(state, draft => {
			// 모든 로딩 상태 해제
			draft.renamingBoxes = {};
		}),
	[actions.DELETE_SAVED_BOX]: (state, action) => 
		produce(state, draft => {
			const boxId = action.payload;
			draft.deletingBoxes[boxId] = true;
		}),
	[actions.DELETE_SAVED_BOX_SUCCESS]: (state, action) => 
		produce(state, draft => {
			// 모든 로딩 상태 해제 (목록이 새로워짐)
			draft.deletingBoxes = {};
		}),
	[actions.DELETE_SAVED_BOX_ERROR]: (state, action) => 
		produce(state, draft => {
			// 모든 로딩 상태 해제
			draft.deletingBoxes = {};
		}),
	
	// Add Saved Box Reducers
	[actions.ADD_SAVED_BOX]: (state, action) => 
		produce(state, draft => {
			const { boxId } = action.payload;
			draft.addingBoxes[boxId] = true;
		}),
	[actions.ADD_SAVED_BOX_SUCCESS]: (state, action) => 
		produce(state, draft => {
			// 모든 로딩 상태 해제
			draft.addingBoxes = {};
		}),
	[actions.ADD_SAVED_BOX_ERROR]: (state, action) => 
		produce(state, draft => {
			// 모든 로딩 상태 해제
			draft.addingBoxes = {};
		}),
	[actions.SET_AD_KEYWORD]: (state, action) => ({
		...state,
		adKeyword: action.payload
	}),
	[actions.SHOW_TOKEN_WARNING]: (state, action) => ({
		...state,
		ui: {
			...state.ui,
			tokenWarning: {
				show: true,
				message: action.payload
			}
		}
	}),
	[actions.HIDE_TOKEN_WARNING]: (state, action) => ({
		...state,
		ui: {
			...state.ui,
			tokenWarning: {
				show: false,
				message: ''
			}
		}
	}),
});

export default editor;